import type { VideoAssetDto } from "../api/videoService";

/**
 * 任务级降级聚合(W0-② 收口):逐段 chip(VideoChunkGrid 波3-⑥)已有,但埋在段网格里;
 * 事故 4853196653568 用户全程未察觉参考被拒。聚合到详情页头部一眼可见。
 * 话术纪律:概览不许比实际乐观,也不许比实际具体(只认已实证归因)。
 */
export function degradeSummary(
  chunks: Array<Pick<VideoAssetDto, "degradedFrom" | "degradeReason">>
): string | null {
  const degraded = chunks.filter((c) => c.degradedFrom);
  if (degraded.length === 0) return null;
  const identityLoss = degraded.some((c) => c.degradeReason === "input_image_rejected");
  return identityLoss
    ? `${degraded.length} 段画面因参考图被平台审核拒收而降级,其中人物/产品形象可能未生效——请检查成片后再发布`
    : `${degraded.length} 段画面从图生视频降级为文字生成,画面可能偏离参考`;
}

/**
 * 1030 成片合成降级(字幕 / 营销大字没烧上)—— ai multi_shot.final_subtitle_degrade 写在成片资产的
 * degradeReason 上。降级本身是对的(不能因为烧字幕失败整片作废),看不见才是问题:用户拿到没字幕的片
 * 还以为是正常的。点「应用并重新合成」不花积分,通常就能补上。
 */
export function finalDegradeNotice(reason: string | null | undefined): string | null {
  switch (reason) {
    case "subtitles_degraded:subtitles_dropped":
      return "这条成片的字幕没能烧进画面(配音正常)。点下方「合成成片」再试一次,不花积分。";
    case "subtitles_degraded:marketing_text_dropped":
      return "这条成片的营销大字没能叠上(字幕和配音正常)。点下方「合成成片」再试一次,不花积分。";
    case "subtitles_degraded:copy_fallback":
      return "这条成片只拼接了画面,字幕、配音、背景音乐都没叠上。点下方「合成成片」再试一次(不花积分);反复出现请把任务号发给运营。";
    default:
      return null;
  }
}

/**
 * 「成片已就绪」那排标签按**实际烧进去的**来:降级了就把没叠上的那项拿掉。
 * 标签原本按本次设置算(开了字幕就挂「字幕」)—— 降级时会和播放器上的黄条自相矛盾(1030 本机真点)。
 */
export function dropDegradedTags<T extends { key: string }>(
  tags: T[],
  reason: string | null | undefined
): T[] {
  if (reason === "subtitles_degraded:subtitles_dropped") {
    return tags.filter((t) => t.key !== "subtitle");
  }
  if (reason === "subtitles_degraded:copy_fallback") {
    return []; // 纯拼接:配音 / 字幕 / BGM / Logo / 二维码都没叠上
  }
  return tags;
}
